export default "__VITE_ASSET__DsZe3oeD__"